import { render, staticRenderFns } from "./project-owners.vue?vue&type=template&id=294a58c5&"
import script from "./project-owners.vue?vue&type=script&lang=js&"
export * from "./project-owners.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports